import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals }) {
  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >
      <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableBody>
          <TableRow
            sx={{
              bgcolor: "success.light",
              "& td": {
                fontWeight: 700,
              },
            }}
          >
            <TableCell colSpan={2} align="center">
              GRAND TOTAL
            </TableCell>

            <TableCell align="right">
              <CurrencyCell value={totals.trolly} />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell value={totals.coachset} />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell value={totals.labourcost} />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell value={totals.materialcost} />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell value={totals.totalcost} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      </TableContainer>
    </Paper>
  );
}